/**
 * Route Mod 定义
 *
 * route-mod 的运行时定义，提供 IRouteService 接口的实现。
 *
 * 此 Mod 封装了 react-router，对外暴露统一的 IRouteService 接口，
 * 业务模块通过依赖注入获取路由能力，无需直接引用 react-router。
 *
 * 使用方式：
 * ```typescript
 * import { routeMod } from '@hvsin/mod-route'
 *
 * await container.loadMods([routeMod, ...businessMods])
 * ```
 */
import { ROUTE_SERVICE_INTERFACE_TAG } from '@hvsin/route-contracts';
import { RouteService } from './route-service.js';
/**
 * route-mod 定义
 *
 * 提供 IRouteService 服务实例，业务 Mod 通过 DI 引用获取路由能力。
 */
export const routeMod = {
    name: 'route',
    serviceDefs: [
        {
            serviceTag: 'routeService',
            serviceImpl: RouteService,
            serviceInterfaceTag: ROUTE_SERVICE_INTERFACE_TAG,
        },
    ],
};
export { RouteService };
//# sourceMappingURL=mod.js.map